module.exports = __webpack_public_path__ + "static/media/celebration.c042eb09.png";